import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/views/Home"),
    children: [
      {
        path: "",
        redirect: { name: "discover" }
      },
      {
        path: "discover",
        name: "discover",
        meta: { showTab: true, pageName: "Book City" },
        component: () => import("@/views/discover/NvDiscover.vue")
      },
      {
        path: "lib",
        name: "lib",
        meta: { showTab: true, pageName: "BookShelf" },
        component: () => import("@/views/shelf/NvShelf.vue")
      },
      {
        path: "content",
        name: "content",
        component: () => import("@/views/book/NvBookContent.vue")
      },
      {
        path: "history",
        name: "history",
        meta: { pageName: "History" },
        component: () => import("@/views/shelf/NvReadHistory.vue")
      },
      {
        path: "me",
        name: "me",
        meta: { showTab: true, pageName: "Mine" },
        component: () => import("@/views/my/Index.vue")
      },
      {
        path: "me/recharge-store",
        name: "recharge-store",
        component: () => import("@/views/my/RechargeStore.vue")
      },
      {
        path: "me/recharge-history",
        name: "recharge-history",
        component: () => import("@/views/my/RechargeHistory.vue")
      },
      {
        path: "me/deposit-history",
        name: "deposit-history",
        component: () => import("@/views/my/HistoryList.vue")
      },
      {
        path: "me/usage-history",
        name: "usage-history",
        component: () => import("@/views/my/HistoryList.vue")
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login")
  },
  {
    path: "*",
    component: () => import("@/views/Temp")
  }
];

const router = new VueRouter({
  routes
});

export default router;
